module.exports = __webpack_public_path__ + "img/character_5.ffcefed1.png";